import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import BestRoundupLawyersWrapper from "@components/layouts/bestrounduplawyersWrapper";

export default function BestRoundupLawyersHome(): ReactElement {
    return (
        <BestRoundupLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Roundup"
                    domain="BestRoundupLawyers.com"
                />
            </div>
        </BestRoundupLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
